"use client";

/**
 * CommandPaletteTrigger — Wave 34 Claude Design .header-search class.
 */
import * as React from "react";

export function CommandPaletteTrigger(): React.JSX.Element {
  const trigger = () => {
    document.dispatchEvent(new KeyboardEvent("keydown", { key: "k", metaKey: true, bubbles: true }));
  };
  return (
    <button type="button" onClick={trigger} className="header-search" aria-label="Komut paleti aç">
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden>
        <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <span className="header-search-placeholder">Ara veya komuta git…</span>
      <span className="kbd">⌘K</span>
    </button>
  );
}
